import config from '../config';

export const getAllProducts = async  (filters = {}) => {
    const query = new URLSearchParams(filters).toString();
  const response = await fetch(`${config.apiUrl}/products/search/param=?&${query}`);

  if (!response.ok) throw new Error('Failed to fetch products');
  return response.json();
};

export const fetchProductsByCategory = async (categoryId, filters = {}) => {
  const query = new URLSearchParams(filters).toString();
  const response = await fetch(`${config.apiUrl}/category/${categoryId}/?${query}`);

  if (!response.ok) throw new Error('Failed to fetch products by category');
  return response.json();
};

export const fetchProductById = async (categoryId, productId, productName) => {
  const response = await fetch(
    `${config.apiUrl}/category/${categoryId}/product/${productId}/${productName}`
  );

  if (!response.ok) throw new Error('Failed to fetch product details');
  return response.json();
};

export const createProduct = async (productData) => {
  const response = await fetch(`${config.apiUrl}/products/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const deleteProduct = async (productId) => {
  const response = await fetch(`${config.apiUrl}/products/${productId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const editProduct = async (productData) => {
  const response = await fetch(`${config.apiUrl}/products/${productData.product_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const uploadProductImages = async (productId, imageData) => {
  const response = await fetch(`${config.apiUrl}/products/${productId}/images`, {
    method: 'POST',
    body: imageData, // Assuming imageData is a FormData object
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};

export const deleteProductImage = async (imageId) => {
    const response = await fetch(`${config.apiUrl}/products/images/${imageId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });
  
    if (!response.ok) {
      const errorResponse = await response.json(); // Parse the error response
      throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
    }
    return response.json();
  };
  
